import styled from '@emotion/styled';
import { sunrisePrimitives, theme } from '@vfit/shared/themes';

interface ContainerProps { color?: string; textColor?: string };

export const Container = styled.div<ContainerProps>`
  width: 100%;
  background-color: ${({ color }) => color || sunrisePrimitives.cyanDark};
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.h6};
  line-height: ${theme.typography.lineHeight.h6};
  color: ${({ textColor }) => textColor || theme.colors.text.inverse};
`;
